import type { ChapterId, TourChapter } from "../types";
import { FLIGHTS_CHAPTER } from "./flights";
import { VIEWER_CHAPTER } from "./viewer";
import { FRAMES_CHAPTER } from "./frames";
import { OFFLINE_CHAPTER } from "./offline";

export const CHAPTER_ORDER: ChapterId[] = ["flights", "viewer", "frames", "offline"];

export const CHAPTERS: Record<ChapterId, TourChapter> = {
  flights: FLIGHTS_CHAPTER,
  viewer: VIEWER_CHAPTER,
  frames: FRAMES_CHAPTER,
  offline: OFFLINE_CHAPTER,
};

/** Route → chapter. Mirrors the router in App.tsx; null for routes without a tour. */
export function routeToChapter(pathname: string): ChapterId | null {
  if (/^\/offline\/?$/.test(pathname)) return "offline";
  if (/^\/flights\/?$/.test(pathname)) return "flights";
  if (/^\/flights\/[^/]+\/frames\/?$/.test(pathname)) return "frames";
  if (/^\/flights\/[^/]+\/?$/.test(pathname)) return "viewer";
  return null;
}
